import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import FormHelperText from '@mui/material/FormHelperText';
import { useInput, useResourceContext } from 'react-admin';

import { http } from '@network';

interface Props {
  source: string;
  label?: string;
  hideLabel?: boolean;
  className?: string;
}

export const LoadAutocompleteInput = ({
  source,
  label,
  hideLabel = false,
  className,
}: Props) => {
  const {
    field,
    fieldState: { isTouched, error },
  } = useInput({ source });
  const resource = useResourceContext();
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    (async () => {
      const url = `${resource}/options/${source}`;
      const response = await http.get<string[]>(url);
      setOptions(response.data);
    })();
  }, []);

  const inputLabel = label || source.substr(0, 1).toUpperCase().concat(source.substr(1));

  return (
    <FormControl fullWidth className={className}>
      <Autocomplete
        fullWidth
        freeSolo
        options={options}
        value={field.value || ''}
        onChange={(_, newValue) => field.onChange(newValue)}
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            {...field}
            name={source}
            label={hideLabel ? undefined : inputLabel}
            error={!!(isTouched && error)}
            helperText={isTouched && error ? `${error}` : null}
            InputLabelProps={{ shrink: true }}
            variant="standard"
            size="small"
          />
        )}
      />
      {/*// @ts-ignore*/}
      <FormHelperText>{isTouched && error ? error.message?.message : null}</FormHelperText>
    </FormControl>
  );
};
